export default "__VITE_ASSET__BTl3ASBH__"